import React, { forwardRef } from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { Icon } from "../Icon/index.mjs.mjs";
import { StyledContainer, StyledImage, StyledLabel } from "./Avatar.styles.mjs.mjs";
export const Avatar = forwardRef(function Avatar({ label, size, src, alt = '', role = 'presentation', icon, ariaLabel, ...restProps }, ref) {
    const avatarProps = {
        size,
        ref,
        'aria-label': ariaLabel,
        outerSpacing: useSpacing(restProps),
        ...pickComponentCommonProps(restProps),
        ...pickDataProps(restProps),
        ...pickAriaProps(restProps),
    };
    const getAvatarVariant = () => {
        if (src) {
            return React.createElement(StyledImage, { src: src, alt: alt, role: role });
        }
        if (icon) {
            const iconSize = size === 'large' ? 'large' : size === 'medium' ? 'small' : 'xs';
            return React.createElement(Icon, { name: "user", size: iconSize });
        }
        return React.createElement(StyledLabel, { size: size }, label);
    };
    return (React.createElement(StyledContainer, { ...avatarProps }, getAvatarVariant()));
});
//# sourceMappingURL=Avatar.mjs.mjs.map